import { Checkbox, Label } from "flowbite-react";

// One named group of stage checkboxes bound to a hubspot_customizations key
// (e.g. active_deal_stages). Checkbox ids are prefixed with the group key so
// the same stage can appear in several groups without id collisions.
export const StageChecklist = ({ group, stages, selected, onChange }) => {
  const selectedIds = (selected ?? []).map((stage) => stage.id);

  const toggle = (stage, checked) => {
    const current = selected ?? [];
    onChange(
      checked
        ? [...current, { id: stage.id, name: stage.label }]
        : current.filter((s) => s.id !== stage.id),
    );
  };

  return (
    <div>
      <p className="text-sm font-medium text-gray-700">
        {group.label}
        {group.optional && (
          <span className="ml-1 text-xs font-normal text-gray-400">
            (optional)
          </span>
        )}
      </p>
      {group.description && (
        <p className="mb-2 text-xs text-gray-500">{group.description}</p>
      )}
      <div className="flex flex-row flex-wrap gap-x-4 gap-y-2">
        {stages.map((stage) => (
          <div key={stage.id} className="flex items-center gap-2">
            <Checkbox
              id={`${group.key}-${stage.id}`}
              checked={selectedIds.includes(stage.id)}
              onChange={(e) => toggle(stage, e.target.checked)}
            />
            <Label htmlFor={`${group.key}-${stage.id}`}>{stage.label}</Label>
          </div>
        ))}
      </div>
    </div>
  );
};
